// All timestamps are stored in UTC (timestamptz). Display is always Africa/Johannesburg.
export const DISPLAY_TZ = "Africa/Johannesburg";
